import Construction from '../assets/construction.jpg';
import Engineering from '../assets/engineering.png';
import Corrosion from '../assets/corrosion.png';
import Contracting from '../assets/contracting.png';
import Procurement from '../assets/procurement.png';

const WhatWeDoData = [
    {
        title: 'Construction',
        image: Construction,
        description: 'We provide top-notch construction services.',
        link: '/Construction'
    },
    {
        title: 'Engineering',
        image: Engineering,
        description: 'Our engineering team is highly skilled and experienced.',
        link: '/Engineering'
    },
    {
        title: 'Corrosion Control',
        image: Corrosion,
        description: 'We offer advanced corrosion control solutions.',
        link: '/Corrosion'
    },
    {
        title: 'Contracting',
        image: Contracting,
        description: 'We handle contracting projects with professionalism.',
        link: '/Contracting'
    },
    {
        title: 'Procurement',
        image: Procurement,
        description: 'Our procurement services are efficient and reliable.',
        link: '/Procurement'
    }
];

export default WhatWeDoData;


